<template>
  <div class="add-image col-12">
    <div class="add-image__title">Фотографии</div>
    <div class="row">
      <div
        class="position-relative col-3"
        v-for="image in files"
        :key="image.id">
        <div
          class="add-image__image"
          @click="handleImage(image.fullPath)">
          <img :src="image.fullPath">
        </div>
        <div
          class="add-image__delete"
          @click="removeFile(image.id)">
          <i class="fa fa-times fa-2x"/>
        </div>
      </div>
      <div
        v-if="maxFiles !== false"
        class="add-image__image col-3">
        <div
          :class="{'add-image__add-button--loading': loading}"
          class="add-image__add-button"
          @click="inputInit()">
          <div class="text-center pt-2">
            <i
              :class="{'fa-spin': loading}"
              class="fa fa-plus-circle fa-3x"/>
            <p v-if="loading">Сохранение...</p>
            <p v-else="loading">{{ maxFiles }}</p>
          </div>
        </div>
      </div>
    </div>
    <input
      ref="fileInput"
      type="file"
      name="img"
      multiple
      :accept="acceptTypes"
      @change="beforeOnFileChange">
    <Lightbox
      :visible="visible"
      :imgs="imgUrls"
      :index="index"
      @hide="handleImage('')"/>
  </div>
</template>

<script>
import {apiDomain, getHeader} from './../../../config'
import { mapActions } from 'vuex'
import { ADD_TOAST_MESSAGE } from 'vuex-toast'
import Lightbox from 'vue-easy-lightbox'

export default {
  name: 'TcAddImages',
  props: {
    value: {
      type: Array,
      default: () => []
    }
  },
  components: {
    Lightbox
  },
  data () {
    return {
      files: this.value.slice(), // Копия, иначе read-only
      loading: false,
      visible: false,
      index: 0,
      acceptTypes: ['image/jpeg', 'image/pjpeg', 'image/png']
    }
  },
  computed: {
    maxFiles: function () {
      let maxFiles = 30
      if (maxFiles - this.files.length === maxFiles) {
        return 'Добавить фото'
      }
      if (maxFiles - this.files.length > 0) {
        return 'Осталось ' + (maxFiles - this.files.length) + ' фото'
      }
      if (maxFiles - this.files.length <= 0) {
        return false
      }
    },
    imgUrls: function () {
      let urls = []
      this.files.forEach(item => {
        urls.push(item.originPath)
      })
      return urls
    }
  },
  methods: {
    handleImage (url) {
      if (url === '') {
        this.visible = false
        return true
      }
      this.files.forEach((item, index) => {
        if (item.fullPath === url) {
          this.index = index
        }
      })
      this.visible = !this.visible
    },
    beforeOnFileChange () {
      this.loading = true
      let fileTypeCheck = false
      let files = this.$refs.fileInput.files
      for (let i = 0; i < files.length; i++) {
        let file = files[i]
        if (this.acceptTypes.includes(file.type)) {
          fileTypeCheck = true
        }
      }
      if (fileTypeCheck) {
        this.onFileChange()
      } else {
        this.loading = false
        this.addToast({
          text: 'Произошла ошибка: Неверный тип изображения',
          type: 'danger',
          dismissAfter: 10000
        })
      }
    },
    onFileChange () {
      this.loading = true
      let files = this.$refs.fileInput.files
      let formData = new FormData()
      for (let i = 0; i < files.length; i++) {
        let file = files[i]
        formData.append('files[' + i + ']', file)
      }
      formData.append('width', '240')
      formData.append('height', '120')
      let headers = getHeader()
      this.$http.post(this.getUploadUrl() + '/upload-photos', formData, {
        headers: {
          'Accept': headers['Accept'],
          'X-Api-Token': headers['X-Api-Token'],
          'Content-Type': 'multipart/form-data'
        }
      })
        .then(response => {
          response.data.files.forEach(file => {
            this.files.push({
              originPath: file.fullPath,
              fullPath: file.fullPath,
              id: file.id,
              savePath: file.savePath
            })
          })
          this.loading = false
        })
        .catch(error => {
          console.log(error)
          this.loading = false
          this.addToast({
            text: 'Произошла ошибка:' + error,
            type: 'danger',
            dismissAfter: 10000
          })
        })
    },
    getUploadUrl () {
      return apiDomain + 'api/techcenter/' + this.$route.params.id
    },
    inputInit () {
      if (!this.loading) {
        this.$refs.fileInput.click()
      }
    },
    removeFile (id) {
      let oldFiles = this.files
      this.files = this.files.filter(val => {
        return val.id !== id
      })
      this.$http.post(this.getUploadUrl() + '/remove-photo', {id}, { headers: getHeader() })
        .catch(error => {
          this.files = oldFiles
          this.addToast({
            text: 'Произошла ошибка:' + error,
            type: 'danger',
            dismissAfter: 10000
          })
        })
    },
    ...mapActions({
      addToast: ADD_TOAST_MESSAGE
    })
  }
}
</script>

<style scoped lang="scss">
.add-image {
  position: relative;
  background: #383e4b;
  color: white;
  border-radius: 0.25rem;
  padding: 1.25rem 1.25rem 0;

  &__title {
    margin-bottom: .5rem;
  }

  &__image {
    overflow: hidden;
    height: 120px;
    margin-bottom: 30px;
    cursor: pointer;

    img {
      width: auto;
      height: auto;
      max-width: 200%;
      min-height: 120px;
    }
  }

  &__add-button {
    border: 3px dashed rgba(255, 255, 255, 0.6);
    border-radius: 0.25rem;
    opacity: 0.6;
    height: 120px;
    transition: 0.3s;
    cursor: pointer;

    &:hover {
      border: 3px dashed rgba(255, 255, 255, 0.9);
      opacity: 0.9;
    }

    &--loading {
      cursor: wait;
    }
  }

  &__delete {
    position: absolute;
    color: #c4c5c9;
    top: -14px;
    right: 2px;
    cursor: pointer;

    &:hover {
      color: #eeeff3;
    }
  }

  input {
    display: none;
  }
}
.modal {
  left: 50px!important;
}
</style>



// WEBPACK FOOTER //
// TcAddImages.vue?22239bc9